interface EnvironmentData {
  pensieveAppName: string;
  pensieveAppKey: string;
  cdhAPIConsumerKey: string;
  APIConsumerKey: string;
  domain: string;
  envName: string;
  LDClientID: string;
  saltKey?: string;
  watchlistRoute?: string;
  siteCoreApiConsumerKey?: string;
  siteCoreApiUrl?: string;
  saveContainerAPIConsumerKey?: string;
  accessTokenLink?: string;
  redirectUrl?: string;
}

export const environmentData: EnvironmentData = {
  pensieveAppName: import.meta.env.VITE_TNT_PENSIEVE_APP_NAME,
  pensieveAppKey: import.meta.env.VITE_TNT_PENSIEVE_APP_KEY,
  cdhAPIConsumerKey: import.meta.env.VITE_TNT_API_CONSUMER_KEY,
  domain: import.meta.env.VITE_TNT_API_DOMAIN,
  envName: import.meta.env.VITE_TNT_ENVIRONMENT_NAME,
  APIConsumerKey: import.meta.env.VITE_TNT_WRAPPER_API_CONSUMER_KEY,
  LDClientID: import.meta.env.VITE_LD_CLIENT_ID,
  saltKey: import.meta.env.VITE_TAS_API_CRYPTO_SALT,
  watchlistRoute: import.meta.env.VITE_WATCHLIST_ROUTE,
  siteCoreApiConsumerKey: import.meta.env.VITE_SOP_SITECORE_CONSUMER_KEY,
  siteCoreApiUrl: import.meta.env.VITE_SOP_SITECORE_API_URL,
  saveContainerAPIConsumerKey: import.meta.env.VITE_SAVE_CONTAINER_API_CONSUMER_KEY,
  accessTokenLink: import.meta.env.VITE_TNT_ACCESS_TOKEN,
  redirectUrl: import.meta.env.VITE_REDIRECT_URL
};
